import React from 'react';
import { BookOpen, Copy, Check, Info } from 'lucide-react';

const TOOLTIP_TEXT =
  "Fonti validate dalla pipeline a supporto delle affermazioni dell'articolo. Verifica e cita queste fonti come riferimenti autorevoli prima di pubblicare.";

const escapeHtml = (s) =>
  String(s ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const buildHtmlList = (sources) =>
  '<ul>\n' +
  sources
    .map(
      (s) =>
        `  <li><a href="${escapeHtml(s.url)}" target="_blank" rel="noopener">${escapeHtml(
          s.title || s.url
        )}</a></li>`
    )
    .join('\n') +
  '\n</ul>';

const buildTextList = (sources) =>
  sources.map((s, i) => `${i + 1}. ${s.title || s.url} — ${s.url}`).join('\n');

const SourcesCitedBlock = ({
  sources,
  copiedId,
  onCopy,
  entryId,
  w = (o) => `rgba(255,255,255,${o})`,
  t = {},
}) => {
  const list = Array.isArray(sources) ? sources.filter((s) => s && s.url) : [];
  if (list.length === 0) return null;

  const htmlCopyId = `sources-cited-html-${entryId}`;
  const textCopyId = `sources-cited-text-${entryId}`;

  const btnStyle = {
    padding: '4px 10px',
    borderRadius: '6px',
    fontSize: '10.5px',
    fontWeight: 600,
    cursor: 'pointer',
    border: `1px solid ${t.border || 'rgba(0,0,0,0.1)'}`,
    background: 'transparent',
    color: '#10A37F',
    display: 'inline-flex',
    alignItems: 'center',
    gap: '4px',
  };

  return (
    <div
      style={{
        marginTop: '14px',
        padding: '14px',
        background: 'rgba(16,163,127,0.04)',
        borderRadius: '10px',
        border: '1px solid rgba(16,163,127,0.15)',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          marginBottom: '12px',
          flexWrap: 'wrap',
        }}
      >
        <BookOpen size={13} color="#10A37F" />
        <span
          style={{
            fontSize: '11px',
            fontFamily: "'JetBrains Mono', monospace",
            color: '#10A37F',
            fontWeight: 600,
          }}
        >
          FONTI CITATE ({list.length})
        </span>
        <span
          title={TOOLTIP_TEXT}
          style={{
            display: 'inline-flex',
            cursor: 'help',
            color: '#10A37F',
            opacity: 0.6,
          }}
        >
          <Info size={12} />
        </span>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: '6px' }}>
          <button onClick={() => onCopy?.(buildHtmlList(list), htmlCopyId)} style={btnStyle}>
            {copiedId === htmlCopyId ? (
              <><Check size={11} /> Copiato</>
            ) : (
              <><Copy size={11} /> Copia HTML</>
            )}
          </button>
          <button onClick={() => onCopy?.(buildTextList(list), textCopyId)} style={btnStyle}>
            {copiedId === textCopyId ? (
              <><Check size={11} /> Copiato</>
            ) : (
              <><Copy size={11} /> Copia Testo</>
            )}
          </button>
        </div>
      </div>
      {list.map((s, i) => {
        const descriptions = Array.isArray(s.descriptions)
          ? s.descriptions.filter(Boolean)
          : [];
        return (
          <div
            key={i}
            style={{
              fontSize: '12px',
              marginBottom: '6px',
              display: 'flex',
              flexWrap: 'wrap',
              gap: '6px',
              lineHeight: 1.55,
            }}
          >
            <span
              style={{
                color: t.textMuted || '#7a7a8e',
                fontFamily: "'JetBrains Mono', monospace",
                fontSize: '11px',
                minWidth: '18px',
              }}
            >
              {i + 1}.
            </span>
            <a
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: '#10A37F',
                textDecoration: 'none',
                fontWeight: 500,
                wordBreak: 'break-word',
              }}
            >
              {s.title || s.url}
            </a>
            {descriptions.length > 0 && (
              <span
                style={{
                  color: t.textMuted || '#7a7a8e',
                  fontSize: '11.5px',
                }}
              >
                — {descriptions.join(', ')}
              </span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SourcesCitedBlock;
